import { SlideChannel } from 'interfaces/slide';
import { StainType } from 'interfaces/stainType';
import { find } from 'lodash';

// Protocol: docs/agents/multiplex-modality.md
export type ChannelModality = 'dna' | 'rna' | 'mif';

export const CHANNEL_MODALITY_LABELS: Record<ChannelModality, string> = {
  dna: 'DNA',
  rna: 'RNA probe',
  mif: 'mIF',
};

export const isRnaChannel = (channel?: SlideChannel | null) => channel?.channelModality === 'rna';

export const getMarkerTypeStain = (markerType: string, stainTypeOptions: StainType[] = []) =>
  find(stainTypeOptions, { id: markerType });

// RNA only from slide.channels (or the backend aggregate built from it); DNA/mIF only from the marker type's stain row.
export const getEffectiveChannelModality = ({
  markerType,
  stainTypeOptions = [],
  channel,
  channelModalities,
}: {
  markerType: string;
  stainTypeOptions?: StainType[];
  channel?: SlideChannel | null;
  channelModalities?: Record<string, string>;
}): ChannelModality => {
  if (isRnaChannel(channel) || channelModalities?.[markerType] === 'rna') {
    return 'rna';
  }
  return getMarkerTypeStain(markerType, stainTypeOptions)?.dna ? 'dna' : 'mif';
};
